import { useParams } from "react-router-dom";
import usePaginationSearchURL from "../../../common/hooks/usePaginationSearchURL";
import { useAuth } from "../../auth/hooks";
import usePlanBTCore from "./core/usePlanBTCore";
import useSinglePlanBTCore from "./core/useSinglePlanBTCore";
import usePoleCore from "./core/usePoleCore";
import { useMicroNavigator } from "../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import useSinglePoleCore from "./core/useSinglePoleCore";
import useStreetLightCore from "./core/useStreetLightCore";
import useSingleStreetLightCore from "./core/useSingleStreetLightCore";
import usePlanLinkCore from "./core/usePlanLinkCore";
import useSinglePlanLinkCore from "./core/useSinglePlanLinkCore";
import { useGenericAPI } from "../../../utils/genericAPI/useGenericAPI";
import { NodePlan } from "../types/node.types";
import { getBaseURLNodePlanBT } from "../services/planAPI";



export const usePlanBT = () => {
    const {getCurrentPage, getQuerySearch, setQuerySearch,goToPage} =usePaginationSearchURL();
    const {getAccountIdUser, getUserId, setHeaderAuthToRequest} = useAuth()

    return usePlanBTCore({getCurrentPage, getQuerySearch, setQuerySearch, goToPage, getAccoundId: getAccountIdUser, getUserId, setHeaderAuthToFutureResquest: setHeaderAuthToRequest});
}

export const useSinglePlanBT = (planBTId?: string) => {
    let planBTIdFound = planBTId;
    const params = useParams();


    if (!planBTId) {
        planBTIdFound = params.planBTId;
    }

    return useSinglePlanBTCore({
        setHeaderAuthToFutureResquest: useAuth().setHeaderAuthToRequest,
        planBTId: planBTIdFound || "",
    });
    
}

export const usePoles = (planBTId?: string) => {

    let planBTIdFound = planBTId;
    const params = useParams();

    if (!planBTId) {
        planBTIdFound = params.planBTId;
    }
    return usePoleCore({
        planBTId: planBTIdFound || "",
        setHeaderAuthToFutureResquest: useAuth().setHeaderAuthToRequest,
    });

}

export const useSinglePole = (config?:{planBTId?: string | null, poleId?: string | null}) => {
    const {planBTId, poleId} = config || {};
    let planBTIdFound = planBTId;
    let poleIdFound = poleId;
    const params = useParams();
    const {currentParams} = useMicroNavigator();

    if (!planBTId) {
        planBTIdFound = params.planBTId;
    }

    if (!poleId) {
        poleIdFound = currentParams?.poleId
    }

    return useSinglePoleCore({
        PlanId: planBTIdFound || undefined,
        PoleId: poleIdFound || undefined,
    });
}


export const useStreetLight = (planBTId?: string) => {

    let planBTIdFound = planBTId;
    const params = useParams();
    if (!planBTId) {
        planBTIdFound = params.planBTId;
    }
    return useStreetLightCore({
        planBTId: planBTIdFound,
    });

}

export const useSingleStreetLight = (streetLightId?: string, planBTId?: string) => {

    let streetLightIdFound = streetLightId;
    const {currentParams} = useMicroNavigator();
    const params = useParams();
    let planBTIdFound = planBTId;

    if (!planBTId) {
        planBTIdFound = params.planBTId;
    }

    if (!streetLightId) {
         streetLightIdFound = currentParams?.streetLightId;
    }
    

    return useSingleStreetLightCore({
        streetLightId: streetLightIdFound || "",
        planBTId: planBTIdFound || "",
    });
}

export const usePlanLink = (planBTId?: string) => {


    const {setHeaderAuthToRequest} = useAuth();
    const params = useParams();
    let planBTIdFound = planBTId;

    if (!planBTId) {
        planBTIdFound = params.planBTId;
    }

    setHeaderAuthToRequest && setHeaderAuthToRequest();
    return usePlanLinkCore({
        setHeaderAuthToFutureResquest: useAuth().setHeaderAuthToRequest,
        planId: planBTIdFound || "",
    });

}

export const usePlanNodes = (planBTId?: string) => {
   let planNodeIdFound = planBTId;
   const {setHeaderAuthToRequest} = useAuth();
    const params = useParams();
    if (!planBTId) {
        planNodeIdFound = params.planBTId;
    }
    const url =  getBaseURLNodePlanBT(planNodeIdFound || "");
    setHeaderAuthToRequest && setHeaderAuthToRequest();
    const {getAllQuery} = useGenericAPI<NodePlan, Partial<NodePlan>, Partial<NodePlan>>({
        baseURL: url,
        APIname: "planNodes",
        pageSize: 10000,
        queryKey: ["planNodes", planNodeIdFound || "none"],
        disableGet: !planNodeIdFound,
    });

    return {
        getAllNodesQuery : getAllQuery,
    }
}

export const usePlanBTNode = (planBTId?: string) => {
    const {getAllNodesQuery} = usePlanNodes(planBTId);
    return {
        getAllNodesQuery
    }
}

export const useSinglePlanLink = (config?:{linkId?: string, planBTId?: string}) => {

    const {currentParams} = useMicroNavigator();
    const params = useParams();
    let planLinkIdFound = config?.linkId;
    let planBTIdFound = config?.planBTId;

    if (!config?.planBTId) {
        planBTIdFound = params.planBTId;
    }

    if (!config?.linkId) {
        planLinkIdFound = currentParams?.linkId;
    }

    

    return useSinglePlanLinkCore({
        linkId: planLinkIdFound ,
        planBTId: planBTIdFound ,
    });

}

